export default "__VITE_ASSET__BcRMqrZe__"